
import DtoDetailCompanyFollowUpRecord from "@/models.machine/DtoDetailCompanyFollowUpRecord";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import CompanyFollowUpRecordDetail from "../../CompanyFollowUpRecord/CompanyFollowUpRecordDetail.vue";
import MiezzForm from "@/models/MiezzForm";
@Options({
  components: {
    CompanyFollowUpRecordDetail,
  },
})
export default class SupplierCompanyFollowUpRecordEdit extends Vue {
  type = EnumCompanyType.Supplier;
  detail = new MiezzForm<DtoDetailCompanyFollowUpRecord, string>(
    "SupplierManagement_FollowUpRecord_Detail"
  );
}
